export const LOCAL_STORAGE_KEYS = {
    rightNavBarClosed: 'right-nav-bar-closed',
};
